import { useNavigate } from 'react-router-dom';

export default function ManualPage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#F5F5F5]">
            {/* Header */}
            <header className="bg-white sticky top-0 z-10 border-b border-gray-100 shadow-sm">
                <div className="max-w-md mx-auto px-4 h-14 flex items-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="w-10 h-10 flex items-center justify-center -ml-2 text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <i className="ri-arrow-left-s-line text-2xl"></i>
                    </button>
                    <h1 className="flex-1 text-center font-bold text-gray-800 pr-8 text-base">
                        オンライン試験マニュアル
                    </h1>
                </div>
            </header>

            <main className="max-w-md mx-auto px-4 py-6 space-y-8">

                {/* Flow Section */}
                <section>
                    <div className="flex items-center gap-2 mb-4">
                        <i className="ri-flow-chart text-orange-500 text-xl"></i>
                        <h2 className="font-bold text-base text-gray-800">試験の流れ</h2>
                    </div>

                    <div className="bg-white rounded-2xl p-6 shadow-sm space-y-6">
                        <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                    <i className="ri-login-box-line text-xl"></i>
                                </div>
                                <div className="w-0.5 h-full bg-gray-100 my-2"></div>
                            </div>
                            <div className="pb-6">
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">ログイン</h3>
                                <p className="text-xs text-gray-500">本人確認を行います</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                    <i className="ri-play-circle-line text-xl"></i>
                                </div>
                                <div className="w-0.5 h-full bg-gray-100 my-2"></div>
                            </div>
                            <div className="pb-6">
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">試験開始</h3>
                                <p className="text-xs text-gray-500">「試験を開始する」をタップ</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                    <i className="ri-edit-line text-xl"></i>
                                </div>
                                <div className="w-0.5 h-full bg-gray-100 my-2"></div>
                            </div>
                            <div className="pb-6">
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">問題に解答</h3>
                                <p className="text-xs text-gray-500">各問題に回答します</p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                    <i className="ri-checkbox-circle-line text-xl"></i>
                                </div>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">解答を提出</h3>
                                <p className="text-xs text-gray-500">すべての解答を送信します</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Precautions Section */}
                <section>
                    <div className="flex items-center gap-2 mb-4">
                        <i className="ri-error-warning-line text-orange-500 text-xl"></i>
                        <h2 className="font-bold text-base text-gray-800">注意事項</h2>
                    </div>

                    <div className="bg-white rounded-2xl p-6 shadow-sm space-y-6">
                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                <i className="ri-timer-line text-xl"></i>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">制限時間</h3>
                                <p className="text-xs text-gray-500 leading-relaxed">
                                    試験には制限時間はございません。ゆっくりあせらず解答してください。
                                </p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-500 shrink-0">
                                <i className="ri-close-circle-line text-xl"></i>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">中断について</h3>
                                <p className="text-xs text-gray-500 leading-relaxed">
                                    試験中にアプリを閉じたり、他のページに移動すると解答が無効になる場合があります。
                                </p>
                            </div>
                        </div>


                    </div>
                </section>

                {/* Recommended Environment Section */}
                <section>
                    <div className="flex items-center gap-2 mb-4">
                        <i className="ri-smartphone-line text-orange-500 text-xl"></i>
                        <h2 className="font-bold text-base text-gray-800">推奨環境</h2>
                    </div>

                    <div className="bg-white rounded-2xl p-6 shadow-sm space-y-6">
                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-500 shrink-0">
                                <i className="ri-smartphone-line text-xl"></i>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">OS / ブラウザ</h3>
                                <p className="text-xs text-gray-500 leading-relaxed">
                                    iOS 15以上、SafariまたはGoogle Chromeの最新版を推奨します。
                                </p>
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-500 shrink-0">
                                <i className="ri-wifi-line text-xl"></i>
                            </div>
                            <div>
                                <h3 className="font-bold text-gray-800 mb-1 text-sm">インターネット接続</h3>
                                <p className="text-xs text-gray-500 leading-relaxed">
                                    安定したWi-Fi環境での受験を強く推奨します。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <button
                    onClick={() => navigate('/select-exam')}
                    className="w-full bg-[#F4B183] text-white font-bold py-4 rounded-xl shadow-sm hover:bg-[#E5A072] transition-colors flex items-center justify-center gap-2 text-sm"
                >
                    試験を開始する
                    <i className="ri-arrow-right-line"></i>
                </button>

            </main>
        </div>
    );
}
